// src/scripts/convertComment.js
import { bbcodeToHtml, containsBBCode } from '../utils/bbcode.utils';

/**
 * Convertit les retours chariot en HTML
 * @param {string} text - Texte avec des retours chariot
 * @returns {string} Texte HTML avec <br> et <p>
 */
const convertLineBreaks = (text) => {
  if (!text) return '';
  
  // Copier le texte pour ne pas modifier l'original
  let html = text;
  
  // Remplacer les caractères \n littéraux par de vrais retours à la ligne
  html = html.replace(/\\n/g, '\n');
  
  // Vérifier s'il contient des retours à la ligne
  if (!html.includes('\n')) return '<p>' + html + '</p>';
  
  // Traiter les doubles retours chariot comme des nouveaux paragraphes
  html = html.replace(/\n\n+/g, '</p><p>');
  
  // Traiter les retours chariot simples comme des <br>
  html = html.replace(/\n/g, '<br>');
  
  // Entourer le contenu avec des balises <p>
  if (!html.startsWith('<p>')) {
    html = '<p>' + html + '</p>';
  }
  
  return html;
};

/**
 * Convertit un commentaire BBCode en HTML et gère les retours chariot
 * @param {string} commentText - Texte du commentaire à vérifier et convertir
 * @returns {string} Texte HTML converti
 */
export const convertCommentIfNeeded = (commentText) => {
  if (!commentText) return '';
  
  // Gérer d'abord les caractères \n littéraux pour la détection correcte du BBCode
  const preprocessedText = commentText.replace(/\\n/g, '\n');
  
  // Vérifier si le commentaire contient du BBCode
  if (containsBBCode(preprocessedText)) {
    // Convertir le BBCode en HTML (inclut déjà la gestion des retours chariot)
    const converted = bbcodeToHtml(commentText);
    console.log('BBCode détecté et converti');
    return converted;
  }
  
  // Si pas de BBCode, retourner le texte tel quel sans conversion des retours à la ligne
  console.log('Pas de BBCode détecté, retour du texte brut');
  return  preprocessedText;
};

/**
 * Fonction pour tester directement la conversion
 * @param {string} input - Texte à convertir (BBCode ou avec retours chariot)
 * @returns {string} Texte HTML converti
 */
export const testBBCodeConversion = (input) => {
  return convertCommentIfNeeded(input);
};

/**
 * Fonction pour tester la conversion avec un exemple contenant uniquement des retours à la ligne
 */
export const testWithLineBreaksExample = () => {
  const example = `Première ligne
Deuxième ligne

Nouveau paragraphe
Encore une ligne

Dernier paragraphe`;
  
  return convertCommentIfNeeded(example);
};

/**
 * Fonction pour tester la conversion avec un exemple complet
 */
export const testWithExample = () => {
  const example = `Toux, un peu de fievre. malade depuis 1 mois avec surinfection bronchique\\nMais tousse depuis des années matin au reveil et soir au brossage de dents.\\n\\npas d'asthme, pas de problemes digestifs\\n\\nPegase - Camp mental ancien proprio Dominique.\\nSe gratte.\\n\\n[b][color=rgb(230, 0, 0)]Validation 07/02/25[/color][/b]\\n\\nBenefices : Oui, incontestablement, gène les premiers jours (chaleur) - Plus de toux, objectif atteint\\nAsthmatique ? Bronches Sifflent et tousse regulièrement\\nContact très positif sur le toucher\\n\\nVerrue au-dessus de la levre qui est revenue depuis 1 an et qui ne fait que pousser\\n\\nPEGASE\\nOn avise au mois de mai\\n\\n[b][color=rgb(230, 0, 0)]Validation 15/04/25[/color][/b]\\nBenefices maintenus\\nMedecin dit que c'est de l'asthme - ne sifle plus depuis traitement sous cortizone Jusqu'à début juin\\n\\nDeblocage\\n[ml][ul][li indent=0 align=left]Polarité[/li][li indent=0 align=left]dangers 4[/li][li indent=0 align=left]Emprise affective 2[/li][li indent=0 align=left]Det monade - 2 ext[/li][/ul][/ml]\\n`;
  
  return convertCommentIfNeeded(example);
};